import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-extenso-v3',
  templateUrl: './extenso-v3.component.html',
  styleUrls: ['./extenso-v3.component.css']
})
export class ExtensoV3Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
